module.exports = __webpack_public_path__ + "static/media/car-4.56742294.jpg";